import { Card, Flex, Stack, Text, Title } from '@mantine/core';
import React, { useEffect, useState } from 'react';
// import FoundSubMerchant from './FoundSubMerchant';
import { useSelector } from 'react-redux';
// import { clearRedux, fetchDetailSubMerchant } from './actions';
import { fetchSessionProtection } from '../../../components/layouts/PageBase/actions';
import FoundCustomer from './FoundCustomer';
import { clearRedux, failedAction, fetchDataCustomerUnblock } from '../actions';
import FormSearchUnblock from '../../../components/forms/FormSearchUnblock';
import PropTypes from 'prop-types';

const ProcessedCustomer = (
  { dispatch = () => {} }
) => {

  const { dataCustomerUnblock, messageCustomerUnblock } =
  useSelector(({ customerSubmissionUnblock }) =>
    customerSubmissionUnblock);
  const { dataHistoryBlock, isLoadingHistoryBlock } = useSelector(({ customerSubmissionUnblock }) =>
    customerSubmissionUnblock);

  const [search, setSearch] = useState('');
  const handleSearch = () => {
    if(search.length < 16){
      dispatch(failedAction('LESS_THAN_16', 'CustomerUnblock'));
    }else{
      dispatch(fetchDataCustomerUnblock({
        nationalityId: search,
        status: 'PROCESSED',
      })).catch(e => e);
    }
  };
  const errors = {
    NOT_FOUND: 'NIK pelanggan tidak ditemukan',
    LESS_THAN_16: 'NIK kurang dari 16 digit'
  };
  useEffect(() => {
    dispatch(fetchSessionProtection());
    // dispatch(clearRedux('dataCustomerUnblock'));
  }, []);

  return (
    <Card withBorder>
      <Flex gap="md" justify="center">
        <img
          height="100"
          src="/assets/illu-setting-merchant.svg"
          width="100"
        />
        <Stack>
          <Title order={4}>Data Pelanggan yang telah Diproses</Title>
          <Text fz={18}>Cari NIK pelanggan untuk melihat rincian hasil pengajuan.</Text>
          <FormSearchUnblock
            clearRedux={() => clearRedux('messageCustomerUnblock')}
            data={{ code: messageCustomerUnblock && 400 }}
            handleSearch={handleSearch}
            messageError={errors[messageCustomerUnblock] || ''}
            placeholder="Masukkan NIK pelanggan..."
            search={search}
            setSearch={setSearch}
          />
        </Stack>
      </Flex>
      <br/>
      {dataCustomerUnblock && <FoundCustomer data={dataCustomerUnblock}
        dispatch={dispatch}
        historyBlock={dataHistoryBlock}
        isLoadingHistory={isLoadingHistoryBlock}/>}
    </Card>
  );
};

export default ProcessedCustomer;

ProcessedCustomer.propTypes = {
  dispatch: PropTypes.func
};
